
const row1 = [
  "single1-chaise",
  "loveseat1-chaise",
  "loveseat1_chaise_and_two_recliners",
  "three_seat_sofa1-chaise",
  "chaise_and_recliner",
  "double_chaise",
  "side_chaise_and_two_recliners",
  "middle_chaise_and_two_recliners",
  "double_loveseat1-chaise",
  "two_chaise_and_two_recliners",
  "quad_chaise",
  "three_chaise_and_two_recliners",
  "five_chaise",
  "double_loveseat_chaise_and_recliner",
  "single1",
  "loveseat1",
  "straight_row_of_two1",
  "curved_row_of_two1",
  "three_seat_sofa1",
  "straight_row_of_three1",
  "curved_row_of_three1",
  "double_loveseat1",
  "curved_double_loveseat1",
  "straight_flanked_loveseat1",
  "curved_flanked_loveseat1",
  "straight_row_of_four1",
  "curved_row_of_four1",
  "captains_chair_double_loveseat1",
  "straight_row_of_five1",
  "curved_row_of_five1",
  "single2",
  "loveseat2",
  "straight_row_of_two2",
  "curved_row_of_two2",
  "three_seat_sofa2",
  "curved_row_of_three2",
  "double_loveseat2",
  "curved_double_loveseat2",
  "straight_flanked_loveseat2",
  "curved_flanked_loveseat2",
  "straight_row_of_four2",
  "curved_row_of_four2",
  "captains_chair_double_loveseat2",
  "straight_row_of_five2",
  "curved_row_of_five2"
]

const row2 = [
  "straight_row_of_three2",
  "single2",
  "loveseat2",
  "straight_row_of_two2",
  "curved_row_of_two2",
  "three_seat_sofa2",
  "curved_row_of_three2",
  "double_loveseat2",
  "curved_double_loveseat2",
  "straight_flanked_loveseat2",
  "curved_flanked_loveseat2",
  "straight_row_of_four2",
  "curved_row_of_four2",
  "captains_chair_double_loveseat2",
  "straight_row_of_five2",
  "curved_row_of_five2"

  
]


const hideAllLayouts = (rows = ['1', '2']) => {
//   const nodesToHide = [

//     "single1-chaise",
//     "loveseat1-chaise",
//     "three_seat_sofa1-chaise",
//     "chaise_and_recliner",
//     "double_chaise",
//     "side_chaise_and_two_recliners",
//     "middle_chaise_and_two_recliners",
//     "double_loveseat1-chaise",
//     "two_chaise_and_two_recliners",
//     "quad_chaise",
//     "three_chaise_and_two_recliners",
//     "five_chaise",
//     "double_loveseat_chaise_and_recliner",
//     "single1",
//     "loveseat1",
//     "straight_row_of_two1",
//     "curved_row_of_two1",
//     "three_seat_sofa1",
//     "straight_row_of_three1",
//     "curved_row_of_three1",
//     "double_loveseat1",
//     "curved_double_loveseat1",
//     "straight_flanked_loveseat1",
//     "curved_flanked_loveseat1",
//     "straight_row_of_four1",
//     "curved_row_of_four1",
//     "captains_chair_double_loveseat1",
//     "straight_row_of_five1",
//     "curved_row_of_five1",
//     "single2",
//     "loveseat2",
//     "straight_row_of_two2",
//     "curved_row_of_two2",
//     "three_seat_sofa2",
//     "curved_row_of_three2",
//     "double_loveseat2",
//     "curved_double_loveseat2",
//     "straight_flanked_loveseat2",
//     "curved_flanked_loveseat2",
//     "straight_row_of_four2",
//     "curved_row_of_four2",
//     "captains_chair_double_loveseat2",
//     "straight_row_of_five2",
//     "curved_row_of_five2"


// //     'single',
// //     'loveseat',
// //     'straight_row_of_two',
// //     'curved_row_of_two',
// //     'three_seat_sofa',
// //     'straight_row_of_three',
// //     'curved_row_of_three',
// //     'double_loveseat',
// //     'curved_double_loveseat',
// //     'straight_flanked_loveseat',
// //     'curved_flanked_loveseat',
// //     'straight_row_of_four',
// //     'curved_row_of_four',
// //     'straight_row_of_five',
// //     'curved_row_of_five',
// //     'captains_chair_double_loveseat',
//   ]
  const promisses = []
    if(rows.includes('1')){
      row1.forEach((node) => {
        if (window.api2) promisses.push(window.api2.node_hide(node))
      })
    }
    if(rows.includes('2')){
      row2.forEach((node) => {
        if (window.api2) promisses.push(window.api2.node_hide(node))
      })
    }
  // })
  return Promise.all(promisses)
}

const showOneLayout = (nodeName) =>
  window.api2 &&
  hideAllLayouts().then(() => {
    return window.api2.node_show(nodeName)
  })

const showLayouts = (nodeNames) => {
  const promisses = [hideAllLayouts()]
  nodeNames.forEach((nodeName, k) => {
    if (window.api2) promisses.push(window.api2.node_show(nodeName))
  })
  return Promise.all(promisses)
}

const showBackRow = (nodeName = 'curved_double_loveseat') => {
  const promisses = []
  if (window.api2) promisses.push(window.api2.node_show(nodeName))

  return Promise.all(promisses)
}

const hideBackRow = () => {
  const promisses = [hideAllLayouts(['2'])]

  return Promise.all(promisses)
}

export { showOneLayout, showLayouts, showBackRow, hideBackRow }
